import {Popper, PopperProps} from "@mui/material";
import React, { memo } from "react";

// HACK:
// there is an issue with autocomplete default popper in zoomed content (which clearly node editor is)
// Issue = Popper appears in "random" offset, which sometimes cause overlap with autocomplete
// It may be caused by floating-ui js lib, and it's wrong positioning calculation in scaled viewport
// Mui Popper is using floating-ui
// similar issue -> https://github.com/floating-ui/floating-ui/issues/2012
// here we use applyStyles modifier to override with custom translate ald "fix" offset issue

const CustomPopper = (props: PopperProps) => {
    return(
        <Popper
            {...props}
            modifiers={[
                {
                    name: 'applyStyles',
                    enabled: true,
                    phase: 'write',
                    fn({state}) {
                        const anchorEl = (props.anchorEl as HTMLDivElement);
                        state.styles.popper.transform = `translate(${anchorEl.offsetLeft}px, ${anchorEl.offsetTop + anchorEl.offsetHeight}px)`;
                    },
                    effect({state}) {
                        const anchorEl = (props.anchorEl as HTMLDivElement);
                        Object.assign(state.elements.popper.style, {
                            position: 'absolute',
                            left: '0',
                            top: '0',
                            transform: `translate(${anchorEl.offsetLeft}px, ${anchorEl.offsetTop + anchorEl.offsetHeight}px)`
                        });
                    }
                }
            ]}
        />
    );
}

export default memo(CustomPopper);